exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".client-image[data-v-4d215a21] {\n  width: 64px;\n  height: 64px;\n}\n.details > p[data-v-4d215a21] {\n  font-size: 80%;\n}\n.list-item[data-v-4d215a21] {\n  border: solid 1px #bfbfbf;\n}\n.list-item[data-v-4d215a21]:not(:first-child) {\n  border-top: none;\n}\n.overlay[data-v-4d215a21] {\n  top: 0;\n  left: 0;\n  min-width: 100%;\n  min-height: 100%;\n  z-index: 2;\n  background-color: rgba(255, 255, 255, 0.7);\n}", ""]);

// exports
